import { Component, Inject, Input, LOCALE_ID, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TransactionDescriptionBase } from '@assetaccountant/assets/components/view-asset/view-asset-transactions/transaction-description-cell-renderer/transaction-description-cell-renderer.component';
import { AssetTransaction } from '@assetaccountant/assets/models/asset-transaction-api-model';
import { RegisterData, RegisterParams } from '@assetaccountant/core/resolvers/register.resolver';
import { RouteService } from '@assetaccountant/core/services/route.service';
import { TypedActivatedRoute } from '@assetaccountant/core/utils/route-utils';

type AssetTransactionAdjusted = AssetTransaction & {
  showResidualValue?: boolean;
};

@Component({
  selector: 'app-transaction-description-cell',
  templateUrl: './transaction-description-cell-renderer.component.html',
  styleUrls: ['./transaction-description-cell-renderer.component.scss'],
  standalone: false,
})
export class PoolTransactionDescriptionCellComponent
  extends TransactionDescriptionBase
  implements OnChanges
{
  @Input() data: AssetTransactionAdjusted;

  assetGroups: undefined;

  constructor(
    @Inject(LOCALE_ID) locale: string,
    @Inject(ActivatedRoute) route: TypedActivatedRoute<RegisterParams, RegisterData>,
    routeService: RouteService,
  ) {
    super(locale, route, routeService);
  }

  ngOnChanges() {
    this.update();
  }
}
